import { render, staticRenderFns } from "./FormulaAdd.vue?vue&type=template&id=256f6bc6"
import script from "./FormulaAdd.vue?vue&type=script&lang=js"
export * from "./FormulaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports